import React, {Component, createContext} from 'react';
import {createComponent} from './components';
import {createEnhancer} from './enhancers';

const
    ContextualComponent = class ContextualComponent extends Component {},

    isContextual = value => !!(value && value.prototype instanceof ContextualComponent),

    createNamedContext = (named, types, value) => {
        const {Provider, Consumer} = createContext(value);

        return {
            name: named,
            Provider,
            Consumer,
            with: (
                name => (
                    createEnhancer(
                        WrappedComponent => (
                            createComponent(
                                `With${named}(${
                                    WrappedComponent.displayName ||
                                    WrappedComponent.name ||
                                    'Component'
                                })`,
                                {},
                                class With extends ContextualComponent {
                                    wrap = value => (
                                        <WrappedComponent {...{
                                            ...this.props,
                                            [name]: value
                                        }} />);

                                    render() {
                                        return <Consumer>{this.wrap}</Consumer>;
                                    }
                                }))))),
            types: types || {}
        };
    };

export {
    createNamedContext,
    isContextual
};
